import { useDispatch } from 'react-redux';
import useApplicationFundingData from './useApplicationFundingData';
import {
  applicationFundingAmount,
  updateApplicationFundingAmount,
} from '../store/actions/funding/fundingActions';
import useApplicationUid from './useApplicationUid';

const useBankApplicationFundingAmountDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationFunding } = useApplicationFundingData();
  const { ApplicationUid } = useApplicationUid();

  const applicationFundingAmountDispatch = ({ data, onSuccess, onError }) => {
    const shouldSkip = data?.Amount === ApplicationFunding?.Amount;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    if (ApplicationFunding?.Amount) {
      dispatch(
        updateApplicationFundingAmount({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        applicationFundingAmount({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { applicationFundingAmountDispatch };
};

export default useBankApplicationFundingAmountDispatch;
